import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'oaibox-bandwidth-create-configuration',
    templateUrl: './bandwidth-create-configuration.component.html',
    styleUrls: ['./bandwidth-create-configuration.component.css'],
    imports: [ReactiveFormsModule]
})
export class BandwidthUSRPCreateConfigurationComponent {

  @Input() public editableBandwidthOptions?: number[];
  @Input() public defaultBandwidthOptions?: number[];
  @Output() public optionsChange: EventEmitter<number[]> = new EventEmitter();

  public bandwidthOptionsForm: FormGroup;

  constructor() {
    this.bandwidthOptionsForm = new FormGroup({
      bandwidth: new FormControl(undefined, Validators.required),
    });
  }

  public addBandwidthOption(): void {
    const bandwidth = this.bandwidthOptionsForm.value.bandwidth;
    if (bandwidth) {
      if (!this.editableBandwidthOptions) this.editableBandwidthOptions = [];
      this.editableBandwidthOptions.push(bandwidth);
      this.optionsChange.emit(this.editableBandwidthOptions);
    }
    this.bandwidthOptionsForm.reset();
  }

  public removeBandwidthOption(index: number): void {
    this.editableBandwidthOptions?.splice(index, 1);
    this.optionsChange.emit(this.editableBandwidthOptions);
  }

}
